import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { AuthService } from "../../services/auth.service";
import Button from "../Button/Button";
import Input from "../Input/Input";
import { signupSchema, signupType } from "./signup.schema";
import style from "../../assets/scss/auth.module.scss";

const authService = AuthService.getInstance();
const Signup = ({ showLogin }: { showLogin: () => void }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(signupSchema),
  });

  const signupUser = async (data: signupType) => {
    try {
      await authService.signup(data);
      toast.success("User created Successfully");
      showLogin();
    } catch (error: any) {
      toast.error(error.message);
    }
  };
  return (
    <div className={style.auth}>
      <form onSubmit={handleSubmit(signupUser)}>
        <Input
          register={register}
          name="firstName"
          label={"First Name"}
          type="text"
          errorMessage={errors.firstName?.message}
        />
        <Input
          register={register}
          name="lastName"
          label={"Last Name"}
          type="text"
          errorMessage={errors.lastName?.message}
        />
        <Input
          register={register}
          name="phoneNumber"
          label={"Phone Number"}
          type="text"
          errorMessage={errors.phoneNumber?.message}
        />
        <Input
          register={register}
          name="email"
          label={"Email"}
          type="text"
          errorMessage={errors.email?.message}
        />

        <Input
          register={register}
          name="password"
          label={"Password"}
          type="password"
          errorMessage={errors.password?.message}
        />
        <Button label="Signup" type="submit" fullWidth={true} />
        <div className={style.auth__switch}>
          <button type="button" onClick={showLogin} className={style.linkButton}>Login</button>
        </div>
      </form>
    </div>
  );
};
export default Signup;
